import { createSlice } from "@reduxjs/toolkit";

const initialPageSize = 100;
const initialState = {
  page: {
    current: 1,
    pageSize: initialPageSize,
    filter: {
      freeText: null,
      // $or: [{ status_id: 1 }, { status_id: 3 }, { status_id: 4 }],
    },
    order: {
      field: "surename",
      order: "ascend",
    },
    items: [],
    finalfilters: {
      status_id: [],
      gender_id: [],
    },
    fields:
      "first_name,surename,status_id,local_id_number,contact_info,birthday,gender_id,address,avatar_url,id,branch_id,branch",
  },
  searchValue: "",
  patientsFilter: "active_and_candidates",
};

const patientsSlice = createSlice({
  name: "patients",
  initialState: initialState,
  reducers: {
    setPage(state, { payload: page }) {
      state.page = page;
    },
    setPatientsFilter(state, action) {
      state.patientsFilter = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    reset(state, action) {
      state.page = initialState.page;
    },
  },
});

export const {
  setPage,
  setPatientsFilter,
  setSearchValue,
  reset,
} = patientsSlice.actions;

export default patientsSlice.reducer;
